<template>
  <div class="internal-history-listing" v-if="getPermission('history:view')">
    <v-container fluid class="custom-bthrust-style">
      <v-layout class="justify-end">
        <div class="mx-2 my-2">
          <v-menu
            v-if="false"
            v-model="datePicker"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                dense
                filled
                flat
                placeholder="Date Range"
                hide-details
                solo
                :disabled="pageLoading"
                v-on:click:clear="clearFilter('dates')"
                clearable
                prepend-inner-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                :value="formattedDate"
                color="cyan"
              ></v-text-field>
            </template>
            <v-date-picker
              color="cyan"
              range
              :disabled="pageLoading"
              v-on:change="getHistories"
              v-model="dates"
            ></v-date-picker>
          </v-menu>
          <DateRangePicker
            placeholder="Date Range"
            v-model="dates"
            v-on:update:model-value="getHistories()"
            v-on:click:clear="clearFilter('dates')"
          ></DateRangePicker>
        </div>
        <div class="mr-2 my-2">
          <v-text-field
            v-model.trim="filter.search"
            v-on:click:clear="clearFilter('search')"
            clearable
            dense
            filled
            flat
            placeholder="Search"
            hide-details
            solo
            :disabled="pageLoading"
            color="cyan"
            @keydown.enter="getHistories"
            @keydown.tab="getHistories"
          ></v-text-field>
        </div>
        <div class="ml-2 my-2">
          <v-tooltip top content-class="custom-top-tooltip">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                depressed
                v-bind="attrs"
                v-on="on"
                class="custom-bold-button white--text"
                color="cyan"
                tile
                :disabled="pageLoading"
                v-on:click="getHistories"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </template>
            <span>Search</span>
          </v-tooltip>
        </div>
      </v-layout>
      <v-simple-table fixed-header height="calc(100vh - 270px)" class="width-100">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="simple-table-th">Description</th>
              <th width="200" class="simple-table-th">IP Address</th>
              <th width="200" class="simple-table-th">Created Time</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="histories.length > 0">
              <tr
                v-for="(history, index) in histories"
                :key="index"
                :class="{
                  'custom-border-top': index == 0,
                  'orange_lighten-5': index % 2 == 0,
                }"
              >
                <td class="simple-table-td">
                  <div v-if="history.added_by" class="mb-1">
                    <span class="font-weight-700">{{
                      history.added_by.display_name
                    }}</span>
                  </div>

                  <template
                    v-if="
                      history &&
                      history.attributes &&
                      history.attributes.module === 'engineer_ot_records' &&
                      history.attributes.old &&
                      history.attributes.new
                    "
                  >
                    <div
                      class="font-weight-600 text--primary font-size-13 mr-2"
                    >
                      {{
                        (history.description || "")
                          .split("\n")[0]
                          .split(". Before:")[0]
                      }} to <span class="text-capitalize"> {{ history?.attributes?.new?.status }}</span>
                    </div>
                      <div
                      v-if="
                        history.remark ||
                        (history.attributes &&
                          history.attributes.new &&
                          history.attributes.new.remarks)
                      "
                      class="mt-1 font-size-12 text--secondary"
                    >
                      <span class="font-weight-600">Remarks:</span>
                      {{
                        history.remark ||
                        (history.attributes &&
                          history.attributes.new &&
                          history.attributes.new.remarks)
                      }}
                    </div>
                    <v-row dense class="mt-1">
                      <v-col cols="12" sm="6">
                        <v-card outlined class="pa-2 grey lighten-5">
                          <div
                            class="font-weight-700 red--text text--darken-2 mb-1 font-size-12"
                          >
                            <v-icon x-small color="red darken-2"
                              >mdi-history</v-icon
                            >
                            Before
                          </div>
                          <div class="font-size-12" style="line-height: 1.6">
                            <div>
                              <span class="font-weight-600">Start:</span>
                              {{
                                formatOtDateTime(
                                  history.attributes.old.ot_start
                                )
                              }}
                            </div>
                            <div>
                              <span class="font-weight-600">End:</span>
                              {{
                                formatOtDateTime(history.attributes.old.ot_end)
                              }}
                            </div>
                            <div>
                              <span class="font-weight-600">Duration:</span>
                              {{ history.attributes.old.total_time || "—" }}
                              &nbsp;|&nbsp;
                              <span class="font-weight-600">Rate:</span>
                              {{ history.attributes.old.rate }} OT
                            </div>
                          </div>
                        </v-card>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-card outlined class="pa-2 cyan lighten-5">
                          <div
                            class="font-weight-700 cyan--text text--darken-3 mb-1 font-size-12"
                          >
                            <v-icon x-small color="cyan darken-3"
                              >mdi-check-circle-outline</v-icon
                            >
                            After
                          </div>
                          <div class="font-size-12" style="line-height: 1.6">
                            <div>
                              <span class="font-weight-600">Start:</span>
                              {{
                                formatOtDateTime(
                                  history.attributes.new.ot_start
                                )
                              }}
                            </div>
                            <div>
                              <span class="font-weight-600">End:</span>
                              {{
                                formatOtDateTime(history.attributes.new.ot_end)
                              }}
                            </div>
                            <div>
                              <span class="font-weight-600">Duration:</span>
                              {{ history.attributes.new.total_time || "—" }}
                              &nbsp;|&nbsp;
                              <span class="font-weight-600">Rate:</span>
                              {{ history.attributes.new.rate }} OT
                            </div>
                          </div>
                        </v-card>
                      </v-col>
                    </v-row>
                  </template>

                  <template
                    v-else-if="
                      history &&
                      history.attributes &&
                      history.attributes.module === 'visit_ot_records'
                    "
                  >
                    <div class="d-flex align-center flex-wrap">
                      <h3
                        class="font-weight-600 text--primary font-size-13 mr-2"
                      >
                        {{ history.description }} to
                        <span class="text-capitalize">{{
                          history.attributes.new.status
                        }}</span>
                      </h3>
                    </div>
                    <div
                      v-if="
                        history.remark ||
                        (history.attributes &&
                          history.attributes.new &&
                          history.attributes.new.remarks)
                      "
                      class="mt-1 font-size-12 text--secondary"
                    >
                      <span class="font-weight-600">Remarks:</span>
                      {{
                        history.remark ||
                        (history.attributes &&
                          history.attributes.new &&
                          history.attributes.new.remarks)
                      }}
                    </div>
                  </template>

                  <!-- Default Read More -->
                  <template v-else>
                    <read-more
                      class="desc-mb"
                      more-str="Read more"
                      :text="history.description || '<em>No description</em>'"
                      link="#"
                      less-str="Read less"
                      :max-chars="150"
                    >
                    </read-more>
                  </template>
                </td>

                <td class="simple-table-td" width="200">
                  {{ history.ip_address }}
                </td>
                <td class="simple-table-td" width="200">
                  <v-tooltip top content-class="custom-top-tooltip">
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip
                        v-if="history.created_at"
                        class="mx-2 my-1 custom-grey-border"
                        color="cyan darken-1"
                        text-color="white"
                        label
                        small
                        v-bind="attrs"
                        v-on="on"
                      >
                        <!-- <v-avatar left>
                          <v-icon>mdi-clock-outline</v-icon>
                        </v-avatar> -->
                        <p class="m-0 custom-nowrap-ellipsis">
                          {{ history.created_at }}
                        </p>
                      </v-chip>
                    </template>
                    <p class="m-0 custom-nowrap-ellipsis">
                      {{ formatDate(history.added_at) }}
                      {{ formatDateStartedNew(history.added_at) }}
                    </p>
                  </v-tooltip>
                </td>
              </tr>
            </template>
            <template v-else>
              <template v-if="pageLoading">
                <tr v-for="row in 3" :key="row">
                  <td>
                    <v-skeleton-loader
                      type="text"
                      class="custom-skeleton table-rows-text"
                    ></v-skeleton-loader>
                  </td>
                  <td>
                    <v-skeleton-loader
                      type="text"
                      class="custom-skeleton table-rows-text"
                    ></v-skeleton-loader>
                  </td>
                  <td>
                    <v-skeleton-loader
                      type="text"
                      class="custom-skeleton table-rows-text"
                    ></v-skeleton-loader>
                  </td>
                  <td v-if="type == 'quotation'">
                    <v-skeleton-loader
                      type="text"
                      class="custom-skeleton table-rows-text"
                    ></v-skeleton-loader>
                  </td>
                </tr>
              </template>
              <tr v-else-if="!pageLoading">
                <td colspan="4">
                  <p
                    class="m-0 row-not-found text-center font-weight-500 font-size-16"
                  >
                    <img
                      :src="$assetURL('media/error/empty.png')"
                      class="row-not-found-image"
                    />
                    Uhh... There are no history at the moment.
                  </p>
                </td>
              </tr>
            </template>
          </tbody>
        </template>
      </v-simple-table>
      <ListingFooter
        :dataLoading="pageLoading"
        :currentPage="current_page"
        :totalPages="total_pages"
        :showingFrom="showingFrom"
        :showingTo="showingTo"
        :totalRows="total_rows"
        removePage
        @update:pagination="onPaginationUpdate"
      ></ListingFooter>
    </v-container>
    <Dialog :commonDialog="historyModal">
      <template v-slot:title> Remark </template>
      <template v-slot:body>
        <v-row>
          <v-col md="12" class="p-5 pl-5 pr-5">
            {{ historyRemark }}
          </v-col>
        </v-row>
      </template>
      <template v-slot:action>
        <v-btn
          :disabled="pageLoading"
          class="mx-2 custom-red-border custom-bold-button red white--text"
          v-on:click="historyModal = false"
        >
          Close
        </v-btn>
      </template>
    </Dialog>
  </div>
</template>

<script>
import { QUERY } from "@/core/services/store/request.module";
import CommonMixin from "@/core/plugins/common-mixin";
import ListingFooter from "@/view/pages/partials/Listing-Footer";
import DateRangePicker from "@/view/components/DateRangePicker";
import moment from "moment-timezone";
import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
import Dialog from "@/view/pages/partials/Dialog.vue";

export default {
  mixins: [CommonMixin],
  data() {
    return {
      dates: [],
      pageLoading: false,
      histories: new Array(),
      filter: {
        search: null,
      },
      per_page: 15,
      current_page: 1,
      offset: 0,
      total_pages: 0,
      total_rows: 0,
      historyRemark: null,
      historyModal: false,
    };
  },
  components: {
    ListingFooter,
    Dialog,
    DateRangePicker,
  },
  props: {
    isCurrentUser: {
      required: false,
      type: Number,
      default: 0,
    },
    type: {
      required: true,
      type: String,
      default: "",
    },
    type_id: {
      required: false,
      type: Number,
      default: 0,
    },
  },
  watch: {
    type_id() {
      let type_id = this.lodash.toSafeInteger(this.type_id);
      if (type_id > 0) {
        this.getHistories();
      }
    },
  },
  methods: {
    hasOtDiff(history) {
      return (
        history &&
        history.attributes &&
        history.attributes.module === "engineer_ot_records" &&
        history.attributes.old &&
        history.attributes.new
      );
    },
    openRemarkHistory(history) {
      let _this = this;
      _this.historyRemark = history?.remark;
      _this.historyModal = true;
    },
    formatDateStartedNew(param) {
      return moment(param).format("hh:mm A");
    },
    clearFilter(field) {
      const _this = this;
      switch (field) {
        case "search":
          _this.filter.search = null;
          break;
        case "dates":
          _this.dates = [];
          break;
      }
      _this.getHistories();
    },
    getHistories() {
      const _this = this;

      if (_this.lodash.isEmpty(_this.dates) === false) {
        if (moment(_this.dates[0]).isAfter(_this.dates[1])) {
          ErrorEventBus.$emit(
            "update:error",
            InitializeError("End Date must be after Start Date.")
          );
          return false;
        }
      }
      _this.pageLoading = true;
      _this.histories = [];
      _this.$store
        .dispatch(QUERY, {
          url: "history",
          data: {
            type: _this.type,
            type_id: _this.type_id,
            per_page: _this.per_page,
            current_page: _this.current_page,
            search: _this.filter.search,
            start_date: _this.dates[0] || null,
            end_date: _this.dates[1] || null,
            is_current_user: _this.isCurrentUser,
          },
        })
        .then(({ data }) => {
          _this.offset = data.offset;
          _this.histories = data.rows;
          _this.total_pages = Math.ceil(data.total_rows / data.per_page);
          _this.current_page = data.current_page;
          _this.total_rows = data.total_rows;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    onPaginationUpdate(page) {
      this.current_page = page;
      this.getHistories();
    },
  },
  mounted() {
    const _this = this;
    /* let type_id = _this.lodash.toSafeInteger(_this.type_id);
    if (type_id > 0) {
      _this.getHistories();
    } */
    _this.getHistories();
  },
  computed: {
    showingFrom() {
      return this.lodash.isEmpty(this.histories) === false
        ? this.offset + 1
        : 0;
    },
    showingTo() {
      return this.offset + (this.histories ? this.histories.length : 0);
    },
  },
};
</script>

<style scoped>
.custom-top-tooltip {
  z-index: 99999 !important;
}
</style>
